import Vue from 'vue'
import Toast from 'vue-easy-toast'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import plugins from './plugins/index.js'
import behavior from './plugins/behavior/index.js'
import './styles.styl'
import {initDocumentFontSize, hmt} from './utils/index.js'
// import './flexboxgrid.min.css'
// import {config} from '@/api/config'
import sa from './plugins/Sa'

initDocumentFontSize()
Vue.use(behavior)
Vue.use(sa)
hmt()
Vue.use(plugins)

Vue.use(Toast)
Vue.prototype.$toast = (message, options) => {
  const defaultOptions = {
    duration: 3000, // 时间
    horizontalPosition: 'center', // 水平位置
    verticalPosition: 'center', // 数值位置
  }
  let prop = Object.assign({}, defaultOptions, options)
  Vue.toast(message, prop)
}

Vue.config.productionTip = false
new Vue({
  store,
  render: h => h(App),
  wechat: plugins.wechat,
  router
}).$mount('#app')

window.mediaQueue = []
